import { Link } from "wouter";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/**
 * Fallback page for any unknown URL.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900">
      <Navbar />

      <main className="flex-1 flex items-center pt-32 pb-24">
        <div className="container max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.14em] text-emerald-700">Error 404</p>
          <h1 className="mt-3 font-display text-[44px] leading-[1.05] md:text-6xl tracking-tight text-slate-900">
            This stop isn't on the route
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            The page you're looking for doesn't exist or has moved.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Link
              href="/"
              className="inline-flex items-center h-12 px-6 rounded-lg bg-emerald-700 text-white font-semibold no-underline hover:bg-emerald-800 transition-colors"
            >
              Back to home
            </Link>
            <Link href="/support" className="text-[15px] font-semibold text-emerald-800 hover:text-emerald-900 no-underline">
              Contact support
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
